import { Fragment, useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import DataTable from "react-data-table-component";
// import { currencyFormat } from '../../utils/currencyFormater';
import DataTableExtensions from "react-data-table-component-extensions";
import { FaTrash } from "react-icons/fa";
import { adminInstance } from "../../config/axios";
import DeleteConfirmPopup from "../common/deleteConfirmPopup";
import { toast } from "react-toastify";

const PromoCodeListingTable = ({ myData, myClass }) => {
  const [data, setData] = useState();

  const [open, setOpen] = useState(false);
  const [activeId, setActiveId] = useState(null);
  useEffect(() => {
    setData(myData);
  }, [myData]);

  const handleDelete = async (row) => {
    try {
      const response = await adminInstance().delete(
        `api/admin/deleteAdminPromoCode/${row._id}`
      );
      if (response?.data?.code === 200) {
        const filteredData = data.filter((item) => item._id !== row._id);
        setData(filteredData);
        toast.success(response?.data?.msg);
      }else{
        toast.error(response?.data?.msg);
      }
    } catch (error) {
      console.log("Error", error);
      toast.error("Something went wrong!");
    } finally {
      handleCloseDelete();
    }
  };

  const handleCloseDelete = () => {
    setOpen(false);
    setActiveId(null);
  };

  const handelOpenDelete = (id) => {
    setActiveId(id);
    setOpen(true);
  };

  const columnDefs = [
    {
      name: "S. No",
      selector: (row, index) => index + 1,
      sortable: false,
    },
    {
      name: "Referral Code",
      selector: (row) => row?.referralCode,
      sortable: true,
    },
    {
      name: "CreateBy",
      selector: (row) => row?.createdBy,
      sortable: true,
    },
    {
      name: "Used Count",
      selector: (row) => row?.usedCount,
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <FaTrash
          onClick={() => handelOpenDelete(row)}
          style={{
            color: "red",
            cursor: "pointer",
            fontSize: "16px",
          }}
          title="Delete Promo Code"
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
    },
  ];

  return (
    <div>
      <Fragment>
        <DataTableExtensions
          columns={columnDefs}
          data={data}
          print={false}
          export={false}>
          <DataTable
            data={data}
            columns={columnDefs}
            className={myClass}
            pagination
            striped={true}
            center={true}
          />
        </DataTableExtensions>
      </Fragment>

      <DeleteConfirmPopup
        title={"Delete Promo Code"}
        open={open}
        handleOnDelete={handleDelete}
        onCloseModal={handleCloseDelete}
        id={activeId}
      />
    </div>
  );
};

export default PromoCodeListingTable;
